module.exports = __webpack_public_path__ + "static/media/10_NL.683a8380.mp3";